export function formatPhone(number) {
  if (number === null || number === undefined) return "";

  const input = String(number);
  const digits = input.replace(/\D/g, "");

  let country = "";
  let cleaned = digits;

  // Só tenta extrair DDI se tiver mais de 11 dígitos
  if (cleaned.length > 11) {
    for (let ddiLength = 1; ddiLength <= 3; ddiLength++) {
      const localLength = cleaned.length - ddiLength;

      if (localLength === 10 || localLength === 11) {
        country = "+" + cleaned.slice(0, ddiLength);
        cleaned = cleaned.slice(ddiLength);
        break;
      }
    }
  }

  if (cleaned.length !== 10 && cleaned.length !== 11) {
    return digits;
  }

  const ddd = cleaned.slice(0, 2);
  const rest = cleaned.slice(2);

  // celular (9 dígitos)
  if (rest.length === 9) {
    return `${country ? country + " " : ""}(${ddd}) ${rest.slice(0, 5)}-${rest.slice(5)}`;
  }

  // fixo (8 dígitos)
  return `${country ? country + " " : ""}(${ddd}) ${rest.slice(0, 4)}-${rest.slice(4)}`;
}
